import { render, staticRenderFns } from "./appContactCard.vue?vue&type=template&id=53072062&scoped=true"
import script from "./appContactCard.vue?vue&type=script&lang=js"
export * from "./appContactCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53072062",
  null
  
)

export default component.exports